module.exports = __webpack_public_path__ + "static/noticias-08--52e0f1bf8d15ceb166ae0b3334f041dd.png";